import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	configDisabledAndHasFailureLogs: {
		id: 'spa-apps-servicedesk-notification-logs.notification-logs-page.notification-logs-tab-layout.enable-outgoing-mail-info.config-disabled-and-has-failure-logs',
		defaultMessage:
			'We couldn’t refresh data because your Jira admin has disabled {boldStart}Outgoing Mail{boldEnd} for {siteUrl}.',
		description: 'Title about the feature being unavailable for users not under evaluation',
	},
});
